import { useMemo } from "react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

export function useDatePickerDialogStyles() {
  return useMemo(
    () => mergeStyleSets({
      dropdown: {
        width: `50px`
      }
    }),
    []
  );
}
